export default __webpack_public_path__ + "static/media/Poppins-Bold.8ce1e99f.eot";